<template>
  <router-link class="nav-link" v-bind="$attrs" :class="classes">
    <div class="nav-link__content">
      <slot />
    </div>
  </router-link>
</template>

<script>
export default {
  name: "TheHeaderMenuItem",
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: "star"
    },
    mobile: Boolean
  },
  computed: {
    classes() {
      return {
        "nav-link_mobile": this.mobile
      };
    }
  }
};
</script>

<style lang="scss" scoped>
$p: ".nav-link";
$color: colors(palette-3);

.nav-link {
  font-weight: fw(bold);
  font-size: 18px;
  text-transform: uppercase;
  color: colors(text-2);
  position: relative;
  height: 20px;
  line-height: 1;
  text-shadow: 0 0 5px #fff;
  letter-spacing: -0.025em;

  &:not(:last-child) {
    margin-right: 29px;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -14px;
    height: 5px;
    background-color: colors(text-4);
    left: 50%;
    transform: translateX(-50%);
    transition: width 0.3s;
    width: 0;
  }

  &:hover {
    text-decoration: none;
  }

  &.router-link-active {
    &::after {
      width: 100%;
    }
  }

  &_mobile {
    text-align: left;
    &:not(:last-child) {
      margin-bottom: 50px;
      margin-right: 0;
    }
  }
}
</style>
